import { Box, getThemeColor } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Container = styled(Box)`
  div {
    flex-shrink: 1;
  }
`

export const Certificate = styled(Box)<{ status?: string }>`
  background-color: ${({ status, theme }) => {
    if (status === 'certified') {
      return `${getThemeColor('success', theme)}15`
    }
    if (status === 'inactive') {
      return `${getThemeColor('grey_3', theme)}15`
    }
    return `${getThemeColor('grey_4', theme)}15`
  }};
  border-radius: 12px;
  padding: 12px 16px;
  width: 100%;
`
